import { Injectable } from '@angular/core';
import { ApiService } from '../../../../shared/services/api/api.service';
import { IPagination } from '../../../../shared/services/api/interface/pagination.interface';

@Injectable({ providedIn: 'root' })
export class MobileStatusOrganizationService {
  constructor(private readonly apiService: ApiService) {}

  getOrganizationstListPagination(filter: any) {
    return this.apiService.post<IPagination>(
      'mobile-status-organizations/get-organizations-list',
      filter
    );
  }

  getUpcomingOrganizationCount(filter:any) {
    return this.apiService.post<{ upcomingCount: number }>(
      'mobile-status-organizations/get-upcoming-organizations-count',filter
    );
  }

  getVehiclesForOrganization(organizationId: number) {
    return this.apiService.get<{ success: boolean; vehiclesList: any[] }>(
      `vehicle/get-vehicles-for-organization/${organizationId}`
    );
  }

  assignVehicle(organizationId: number, vehicleId: number) {
    return this.apiService.post<{ success: boolean; response: any }>(
      `mobile-status-organizations/assign-vehicle`,
      {
        organizationId,
        vehicleId,
      }
    );
  }
}
